import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import DetailTable from './DetailTable';
// import Utils from './Utils';

export default class DialogState extends Component  {

  constructor(props) {
    super(props);

    this.state = {
        // mySum: 0,
        
    }
  }

  // Iniciální načtení dat
  // componentDidMount() {
    
// }

  
  
render() {
  // this.getReservationsShort();
    return(
    <Dialog disableBackdropClick
        open={this.props.myopen} aria-labelledby="alert-dialog-title"  aria-describedby="alert-dialog-description"
        onClose={this.props.onClickClose}
        >
        <DialogTitle  id="answer2-dialog-title">{this.props.myName}</DialogTitle>
        
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {/* {this.state.myData.length} */}
              <DetailTable myData={this.props.myData}>
              </DetailTable>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <p className="center">
          <Button color="primary" variant="contained" autoFocus
          onClick={this.props.onClickClose}
          >
          OK
          </Button>
          </p>
        </DialogActions>
      </Dialog>
    );
}
}
